import { useId as useReactId } from "react";

export const useId = (id?: string) => {
	const generatedId = useReactId();
	const useId = id ?? generatedId;
	const idSelector = `#${useId.replace(/:/g, "\\:")}`;
	return { id: useId, idSelector };
};
